import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

import { InqFormComponent } from '../inq-form/inq-form.component';
import { FollowUpsFormComponent } from '../follow-ups-form/follow-ups-form.component';
import { InqViewComponent } from '../inq-view/inq-view.component';

import { DataService } from '../../../services/data.service';

@Component({
	selector: 'app-inq-list',
	imports: [CommonModule, FormsModule, InqFormComponent, FollowUpsFormComponent, InqViewComponent],
	templateUrl: './inq-list.component.html',
	styleUrl: './inq-list.component.scss',
})
export class InqListComponent {
  @Input() user: any;
  @Input() action: any;
  
  base = 'inquiries';		// important for API calls
  inst_id: number = 0;
  loading = false;
  btnClick: string = "";
  isEdit = false;
  headers: any = null;
	allData: any = [];
  institutes: any = [];
  inqData: any = {};
  actFor: any = {
    "title": "",
    "type": ""
  };
  totalRec: number = 0;

  inq_id: number | null = null;
  errMsg = '';
  okMsg  = '';
  enquiries: any = [{'enquiryNo': 'Inq-2026-67890', 'studentName': 'Sahil Kumar'}];
  leadStatuses: any = [];
  counsellors: any = [{'id': 1, 'name': 'Jagmeet'}, {'id': 2, 'name': 'Arun Sharma'}, {'id': 3, 'name': 'Vipin Mehra'}];
  form: any = {};
  today = new Date().toISOString().split('T')[0];
  followUpModes: any = [];

  constructor(public dataService: DataService, private router: Router) {
    //
  }

  ngOnInit() {
		this.loading = true;
    this.dataService.getAllRecords(this.base).then((res: any) => {
      this.totalRec = res.length;
      this.allData = res;
      this.loading = false;
    });
		this.loading = true;
    this.dataService.getAllRecords('institutes').then((res: any) => {
      this.institutes = res;
      this.loading = false;
    });

    this.leadStatuses  = this.dataService.lead_status;
    this.followUpModes = this.dataService.inquiry_mode;
	}

	ngOnChanges() {
		if(this.action && this.action=='reload') {
			this.ngOnInit();
		}
	}

  newClick() {
    this.isEdit = false;
    this.btnClick = 'addnew';
    this.dataService.updateOuterAction({
      component: 'inquiry',
      action: 'addnew', data: null
    });
  }

  editClick(myData: any) {
    this.isEdit = true;
    this.btnClick = 'modify';
    this.dataService.updateOuterAction({
      component: 'inquiry',
      action: 'edit', data: myData
    });
  }

  reloadData() {
    setTimeout(()=>{
      this.ngOnInit();
    }, 1000);
  }

  showInqDetails(data: any) {
    this.inqData = data;
    this.actFor = {
      "title": "Enquiry Details",
      "type": "inqd"
    };
  }

  doFollowups(myid: any) {
    // this.inq_id = myid;
    // this.actFor = {
    //   "title": "Follow Ups",
    //   "type": "ufup"
    // };
    this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('ufup')]);
  }

  checkEligibility(data: any) {
    localStorage.setItem("data4chk", JSON.stringify(data));
    this.router.navigate(['/dashboard/'+this.dataService.myEncrypt('clg')]);
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        console.log('Response received in component:', response);
        // You can handle your loading states or form resets here:
        this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}
}
